import { forwardRef } from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  CardFooter,
} from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ChevronLeft, Loader2 } from 'lucide-react';
import BuyerInfoForm from '../Components/BuyerInfoForm';
import { Heading } from '@/components/ui/shared/heading';
import { Label } from '@/components/ui/label';
import { CouponItemInfo } from '../Components/CouponItemInfo';
import { useCartData } from '../../CartPage/context/CartDataContext';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const BuyerInfoStep = forwardRef(
  ({ coupon, goPrev, goNext, onQuantityChange }, ref) => {
    const { loading } = useCartData();
    const history = useHistory();

    return (
      <div className="flex flex-col sm:flex-row sm:gap-4 w-full">
        {/* Form Column */}
        <div className="sm:w-2/3">
          <Card className="flex flex-col justify-between">
            <CardHeader>
              <button
                type="button"
                onClick={() => history.goBack()}
                className="flex items-center gap-1 hover:opacity-80 focus:outline-none"
              >
                <ChevronLeft className="w-8 h-8 text-secondary" />
                <Heading variant="2">Dovanų kupono pirkimas</Heading>
              </button>
              <Label variant="subheading">
                Prisijungus prie paskyros, duomenis užpildysime automatiškai.
              </Label>
            </CardHeader>

            <CardContent>
              <BuyerInfoForm ref={ref} onValid={goNext} />
            </CardContent>

            <CardFooter>
              {/* ✅ Desktop-only button */}
              <Button
                type="submit"
                form="buyer-info-form"
                className="hidden sm:flex sm:w-full items-center justify-center"
                onClick={goNext}
                loading={loading}
              >
                {loading && (
                  <Loader2
                    className="h-4 w-4 animate-spin"
                    aria-hidden="true"
                  />
                )}
                Pereiti prie apmokėjimo
              </Button>
            </CardFooter>
          </Card>
        </div>

        {/* Coupon Column */}
        <div className="sm:w-1/3 mt-6 sm:mt-0">
          <CouponItemInfo
            name={`Dovanų Kuponas ${coupon?.price?.toFixed(2)}€`}
            price={coupon?.price?.toFixed(2)}
            showQuantitySelector
            onQuantityChange={onQuantityChange}
          />
        </div>

        {/* ✅ Mobile-only button */}
        <div className="mt-6 sm:hidden w-full">
          <Button
            type="submit"
            form="buyer-info-form"
            className="flex w-full items-center justify-center"
            onClick={goNext}
            loading={loading}
          >
            {loading && (
              <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />
            )}
            Pereiti prie apmokėjimo
          </Button>
        </div>
      </div>
    );
  },
);

export default BuyerInfoStep;
